// Per-page size selector for the property list.
//
// Reads + writes `?size=` via the helpers in
// {@link ./../utils/property-filter-params.ts}. Default 12 is stripped
// from the URL so a fresh visit stays at the clean
// `/properties` instead of `/properties?size=12`.

import { useSearchParams } from "react-router";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import {
  PAGE_SIZE_OPTIONS,
  readPageSize,
  writePageSize,
  type PageSize,
} from "@/features/property/utils/property-filter-params";

interface PropertyPageSizeSelectorProps {
  className?: string;
}

export function PropertyPageSizeSelector({ className }: PropertyPageSizeSelectorProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const size = readPageSize(searchParams);

  const handleChange = (raw: string) => {
    const next = Number(raw) as PageSize;
    setSearchParams(
      (prev) => {
        const out = new URLSearchParams(prev);
        writePageSize(out, next);
        return out;
      },
      { replace: true },
    );
  };

  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 text-[12px] text-muted-foreground",
        className,
      )}
    >
      <span id="page-size-label">Hiển thị</span>
      <Select value={String(size)} onValueChange={handleChange}>
        <SelectTrigger
          aria-labelledby="page-size-label"
          aria-label="Số bất động sản mỗi trang"
          className="h-8 w-[68px] gap-1 px-2 text-[12px]"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PAGE_SIZE_OPTIONS.map((opt) => (
            <SelectItem key={opt} value={String(opt)}>
              {opt} / trang
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
